var AdaptiveImage = require( "../../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js" );

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/empty_search.55714a2c.png","uri@2x": __webpack_public_path__ + "static/media/empty_search.863bd231.png","uri@3x": __webpack_public_path__ + "static/media/empty_search.fd20256f.png",
    width: 60,
    height: 60
});